import Reviews from "components/homepage/reviews";
import ServicesGrid from "components/homepage/servicesGrid";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import LocationBanner from "components/locationBanner";
import Popular from "components/LocationReusableComp/popular";
import SpeceficTranslation from "components/LocationReusableComp/speceficTranslation";
import TrustedTranslation from "components/LocationReusableComp/trustedtranslation";
import React from "react";
import GlobalLeader from "../globalLeader";
import LocalizationMidText from "../localizationMidText";
import TechnicalDocument from "../technicalDocument";
import WhatsAppComp from "../whatsappComp";
import {
  FinancialData,
  FinancialDataSec,
  TripleGridData,
  TripleGridData2,
} from "./config";
import InstitutionIcons from "./InstitutionIcons";
import TripleGrid from "./tripleGrid";

function FinancialTranslation() {
  return (
    <>
      <LocationBanner
        backgroundCol="bg-midBlue"
        title="Financial Translation Services"
        content="Tomedes follows best practices in providing financial translation services to its worldwide clients, including accountancy, banking and insurance firms. Tomedes provides translation, localization, and interpretation services in over 120 languages and 950+ language pairs. All your translation projects come with a 1-year guarantee, rapid delivery, and 24/7 customer support."
        formOrangeHead="Get in touch "
        formWhiteHead="with our financial translation company"
      />
      <InstitutionIcons />
      <LocalizationMidText
        backgroundCol="bg-midBlue"
        orangeMidText="financial"
        content="ranslation services enable companies and financial institutions worldwide to remain compliant in an ever changing global marketplace. Secure your global objectives with the help of our comprehensive financial language solutions."
      />
      <TrustedTranslation
        padding="py-24"
        backgroundCol="bg-darkBlue"
        FirstWhite=""
        headColor="text-lightBlue"
        ColorHead="Accredited"
        SecondWhite="Financial Translation Services"
        Content="Our financial translation services are accredited by the International Organization for Standardization (ISO) so you can be assured that at Tomedes, your financial translations will fit the worldwide standards, as well as the nationwide government standards."
      />
      <GlobalLeader
        backgroundCol="bg-midBlue"
        FirstHead=" "
        ColorHead="Features"
        secondHead=" "
        headcol="text-orange "
        data={FinancialData}
      />
      <WhatsAppComp
        backgroundCol="bg-darkBlue"
        btnHoverCol="hover:bg-newBlue-100"
        btnCol="bg-lightBlue"
        fHead="Contact"
        secondHead="us for more information"
        content="There are plenty of ways to contact Tomedes. You can send an email to support@tomedes.com or
        call us at +1 985 239 014. We are also available 24/7 in Whatsapp, click the link below and chat with us today."
        whatsUp
      />
      <TripleGrid cardData={TripleGridData} backgroundCol="bg-midBlue" />
      <TripleGrid
        cardData={TripleGridData2}
        backgroundCol="bg-darkBlue"
        head=" "
        head2
      />

      <TechnicalDocument
        backgroundCol="bg-midBlue"
        headColor="text-orange"
        colHead="Looking"
        secondHead="for financial translation services?"
        para="If you are seeking financial translation services, look no further. Tomedes has the expertise to translate documents in any field of finance. Just describe your project and send a sample of your content. We'll respond in 30 minutes."
      />
      <ServicesGrid
        backgroundCol="bg-darkBlue"
        heading="Experienced in a vast array of industries"
        colorComp=" "
        details="Tomedes commands expertise in financial translation services for virtually every industry imaginable, from automotive to legal, and from technology to healthcare."
      />
      <SpeceficTranslation
        backgroundCol="bg-midBlue"
        FirstOrange="Financial"
        SecondWhite="Translation Services for Every
        Financial Sector"
        headColor="text-orange"
        Content="We support all types of financial institutions, such as central banks, retail and commercial banks, internet banks,
        credit unions, savings and loan associations, investment banks and companies, brokerage firms, insurance
        companies, and more."
        backgroundCol="bg-midBlue"
        link=" "
      />
      <Popular
        bottomBorderText
        backgroundCol="bg-darkBlue"
        languageCount="Financial Document Translation in over
        120 Languages and 950+ Language Pairs"
        details="Tomedes can perform financial translations for more than 200 language pairs with native fluency, covering all of the languages used for business around the globe. Our network of thousands of trained and certified linguists includes specialists in the specific terminology of diverse domains."
        bottomHeading="In-demand languages"
        footerTitle="Didn't see the language you need?"
        bottomDetails=" "
        footerDetails="If you didn't see the language you need, there are multitudes of options for you, over 120 in fact. Here is our list of languages."
        location=""
        data={FinancialDataSec}
      />
      <WhatChooseUs backgroundCol="bg-midBlue" />
      <Reviews backgroundCol="bg-darkBlue" />
      <TranslationServices backgroundCol="bg-midBlue" />
    </>
  );
}

export default FinancialTranslation;
